import {
  LIST_WORK_FITNESS_REQUEST,
  LIST_WORK_FITNESS_SUCCESS,
  LIST_WORK_FITNESS_FAIL,
  LIST_WORK_FITNESS_SUMMARY_REQUEST,
  LIST_WORK_FITNESS_SUMMARY_SUCCESS,
  LIST_WORK_FITNESS_SUMMARY_FAIL,
  CREATE_WORK_FITNESS_REQUEST,
  CREATE_WORK_FITNESS_SUCCESS,
  CREATE_WORK_FITNESS_FAIL,
  DETAIL_WORK_FITNESS_REQUEST,
  DETAIL_WORK_FITNESS_SUCCESS,
  DETAIL_WORK_FITNESS_FAIL,
  UPDATE_WORK_FITNESS_REQUEST,
  UPDATE_WORK_FITNESS_SUCCESS,
  UPDATE_WORK_FITNESS_FAIL,
  DELETE_WORK_FITNESS_REQUEST,
  DELETE_WORK_FITNESS_SUCCESS,
  DELETE_WORK_FITNESS_FAIL,
  RESET_WORK_FITNESS
} from '../../constants/work-fitness'

const initialState = {
  loading: false,
  workFitnesses: [],
  workFitnessesSummary: [],
  workFitness: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const workFitnessesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_WORK_FITNESS_REQUEST:
      return { ...state, loading: true }
    case LIST_WORK_FITNESS_SUCCESS:
      return {
        ...state,
        loading: false,
        workFitnesses: action.payload,
        pageable: action.pageable
      }
    case LIST_WORK_FITNESS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        workFitnesses: action?.dummy
      }
    case LIST_WORK_FITNESS_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_WORK_FITNESS_SUMMARY_SUCCESS:
      return { ...state, loading: false, workFitnessesSummary: action.payload, error: null }
    case LIST_WORK_FITNESS_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_WORK_FITNESS_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_WORK_FITNESS_SUCCESS:
      return { ...state, loadingCreate: false, error: null }
    case CREATE_WORK_FITNESS_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_WORK_FITNESS_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_WORK_FITNESS_SUCCESS:
      return { ...state, loadingDetail: false, error: null, workFitness: action.payload }
    case DETAIL_WORK_FITNESS_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_WORK_FITNESS_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_WORK_FITNESS_SUCCESS:
      return { ...state, loadingUpdate: false, error: null }
    case UPDATE_WORK_FITNESS_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_WORK_FITNESS_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_WORK_FITNESS_SUCCESS:
      const workFitnessIdDelete = action.payload
      const workFitnessesDelete = [...state.workFitnesses]

      const indexDelete = workFitnessesDelete.findIndex(
        (workFitness) => workFitness.id === workFitnessIdDelete
      )
      workFitnessesDelete.splice(indexDelete, 1)
      return { ...state, loadingDelete: false, workFitnesses: workFitnessesDelete, error: null }
    case DELETE_WORK_FITNESS_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_WORK_FITNESS:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default workFitnessesReducer
